import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PaymentNote } from './PaymentNote';
import { PriceTag } from './PriceTag';
import { OfferCountdown } from './OfferCountdown';
import { checkoutUrl, kitContents, price } from '../data/kit';
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-4 bg-paper py-20 lg:py-28" aria-labelledby="oferta-titulo" data-id="element-243" data-mp="dex2cfxciobl">
      <div className="mx-auto max-w-6xl px-5" data-id="element-244" data-mp="icylt1yoopnl">
        <div className="mx-auto max-w-2xl overflow-hidden rounded-[2rem] bg-surface shadow-[0_40px_80px_-40px_rgba(18,26,21,0.4)] ring-1 ring-line" data-id="element-245" data-mp="meadre515myy">
          <div className="bg-ink px-6 py-5 text-center text-white sm:px-10" data-id="element-246" data-mp="reporz1uaidr">
            <h2 id="oferta-titulo" className="font-display text-2xl font-black uppercase tracking-tight" data-id="element-247" data-mp="wboiighlcnbf">
              Todo esto por
            </h2>
            <p className="mt-1 text-sm text-white/70" data-id="element-248" data-mp="2y4cp8ztg1svy">
              Valor individual de los 3 volúmenes + bonos: mucho más que el precio de entrada
            </p>
          </div>

          <div className="px-6 py-8 sm:px-10 sm:py-10" data-id="element-249" data-mp="12plcyx2gxjbe">
            <ul className="grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-250" data-mp="xvquty2ihcef">
              {kitContents.map(item => <li key={item.kind} className="flex gap-2.5 text-ink" data-id="element-251" data-mp="syic9wdgb6cn">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-252" data-mp="owwqflixvhqb" />
                  <span data-id="element-253" data-mp="1lmw76398tmjz">
                    <span className="font-semibold" data-id="element-254" data-mp="1ll33mwtxfig7">{item.kind}:</span> {item.title}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-dashed border-line pt-8 text-center" data-id="element-255" data-mp="1clfzw4dq60jz">
              <p className="font-semibold text-muted" data-id="element-256" data-mp="17mlhh3jo6e0e">Hoy accedés al kit completo por:</p>
              <div className="mt-3" data-id="element-257" data-mp="17oxur3ehg074">
                <PriceTag size="lg" align="center" data-id="element-258" data-mp="16sxc83dn0dk" />
              </div>
              <p className="mt-2 font-display text-lg font-extrabold uppercase text-ink" data-id="element-259" data-mp="3scu629zvdhw1">Pago único</p>
              <p className="mt-1 text-muted" data-id="element-260" data-mp="3tu97z3pdh5g6">Sin mensualidades. Sin comprar cada volumen por separado.</p>
              <p className="mt-4 inline-flex rounded-full bg-brand-soft px-4 py-1.5 text-sm font-bold text-brand" data-id="element-261" data-mp="2o84phbnfg53">
                3 volúmenes + 3 bonos · Acceso digital inmediato
              </p>
            </div>

            <div className="mt-8" data-id="element-262" data-mp="3ou5185e9np35">
              <OfferCountdown data-id="element-263" data-mp="3ot3ev4rsvg64" />
            </div>
            <div className="mt-5" data-id="element-264" data-mp="3b2zvqmo7w2kw">
              <CtaButton label="Quiero el Kit Ingresos Online" href={checkoutUrl} fullWidth data-id="element-265" data-mp="3b1x7ynm6yg97" />
            </div>
            <div className="mt-4" data-id="element-266" data-mp="3fvja3luqb1qr">
              <PaymentNote data-id="element-267" data-mp="315ltbqz4pebl" />
            </div>
          </div>
        </div>

        <div className="mx-auto mt-20 max-w-4xl" data-id="element-268" data-mp="31393ysr1k1oi">
          <h3 className="font-display text-3xl font-black tracking-tight sm:text-4xl" data-id="element-269" data-mp="363n8i0tfoths">Pensalo de esta manera</h3>
          <div className="mt-8 grid gap-8 md:grid-cols-2" data-id="element-270" data-mp="2s5yr52yks4hh">
            <div className="text-lg text-muted" data-id="element-271" data-mp="2x3h3727w2ztp">
              <p data-id="element-272" data-mp="2x37c1bb3ymmf">{price} puede comprarte otra cena.</p>
              <p data-id="element-273" data-mp="2dhf6blp53x6h">Una salida.</p>
              <p data-id="element-274" data-mp="2diq9bjarh0wj">Una compra impulsiva.</p>
            </div>
            <div data-id="element-275" data-mp="28j3vb7n3zgmo">
              <p className="text-lg text-muted" data-id="element-276" data-mp="28jnfyw458j4e">O puede darte un sistema para estudiar:</p>
              <p className="mt-2 font-display text-2xl font-black leading-tight text-ink" data-id="element-277" data-mp="2mj4y4smxoy4s">
                Tres formas diferentes de construir una nueva fuente de ingresos.
              </p>
            </div>
          </div>
          <p className="mt-10 text-lg text-muted" data-id="element-278" data-mp="2wfrjdij69r7c">
            No sabemos cuál de las tres va a encajar con vos. Eso lo vas a descubrir ejecutando. Pero solamente
            necesitás que: <span className="font-display text-2xl font-black text-brand" data-id="element-279" data-mp="3674bmb8vujdw">una funcione.</span>
          </p>
        </div>
      </div>
    </section>;
}